<template>
    <transition name="slide-y-transition" mode="out-in">
        <div class="table table_middle" v-if="items.length">
            <modal></modal>
            <table>
                <thead>
                <tr>
                    <th class="caption">Имя</th>
                    <th class="middle">Email</th>
                    <th class="middle">Телефон</th>
                    <th class="middle">Дата/время</th>
                    <th class="icons"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" v-bind:key="item.id" :class="{new_message: !item.is_viewed}">
                    <td class="caption link">
                        <span @click.prevent="onReadItem(item.id, item.is_viewed)">{{item.name}}</span>
                    </td>
                    <td class="middle mail_col">{{item.city}}</td>
                    <td class="middle">{{item.img}}</td>
                    <td class="middle">{{item.created_at}}</td>
                    <td class="icons">
                        <a @click.prevent="onReadItem(item.id, item.is_viewed)" class="view-icon">
                            <icon-eye/>
                            <div class="hint left edit">Смотреть</div>
                        </a>
                        <a class="delete-icon" @click.prevent="onDeleteItem(item)">
                            <icon-delete/>
                            <div class="hint left">Удалить</div>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </transition>
</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
    import faPencilAlt from '@fortawesome/fontawesome-free-solid/faPencilAlt'
    import faTrash from '@fortawesome/fontawesome-free-solid/faTrash'
    import faLink from '@fortawesome/fontawesome-free-solid/faLink'
    import faEye from '@fortawesome/fontawesome-free-solid/faEye'
    import IconEye from '@/components/icons/IconEye.vue'
    import IconDelete from '@/components/icons/IconDelete.vue'
    import Modal from '@/components/Modal'
    import {createNamespacedHelpers} from 'vuex'

    const {mapActions, mapState, mapMutations} = createNamespacedHelpers('mainPage')

    export default {
        computed: {
            faPencilAlt() {
                return faPencilAlt
            },
            faTrash() {
                return faTrash
            },
            faLink() {
                return faLink
            },
            faEye() {
                return faEye
            },
            apiDomain() {
                return this.$store.state.apiDomain
            },
            apiUrls() {
              return this.$store.state.apiUrls
            },
            ...mapState([
                'items'
            ])
        },
        methods: {
            ...mapMutations([
              'setShowModal',
              'setItemForDelete'
            ]),
            onDeleteItem(item) {
              this.setItemForDelete({id: item.id, title: item.title, url: 'feedback', img: item.img});
              this.setShowModal(true);
            },
            updateFeedback(id) {
                this.$http.put(
                    `${this.apiUrls.feedback}/${id}`,
                    {
                      is_viewed: true
                    }
                ).then(() => {
                  this.$http.get(
                    `${this.apiUrls.feedback}/count?search=type_id:${this.$store.state.typeId.reviews.feedback};is_viewed:0&searchJoin=and`
                  ).then(res => {
                    this.$store.commit('setUnreadMessages', res.data.data)
                  })
                })
            },
            onReadItem(id, isViewed) {
                if (!isViewed) {
                  this.updateFeedback(id)
                }
                this.$router.push({ path: `/feedbacks/${id}/view`})
            }
        },
        components: {
            Modal,
            FontAwesomeIcon,
            IconEye,
            IconDelete
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }

    .table table .middle {
      white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/feedbacks/MainTable.vue